import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonValues } from 'src/app/services/commonValues';
import { ApiService } from 'src/app/services/api.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { UtilService } from 'src/app/services/util.service';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';

// import { BussinessPostComponent } from '../../bussiness-post/bussiness-post.component';

@Component({
  selector: 'app-navheadercommunity',
  standalone: true,
  imports: [BsDropdownModule, CommonModule, ReactiveFormsModule, FormsModule, CollapseModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './navheadercommunity.component.html',
  styleUrls: ['./navheadercommunity.component.scss']
})
export class NavheadercommunityComponent implements AfterViewInit, OnInit {

  @ViewChild('communitymenusticky') communitymenustic: ElementRef;
  communitymenustick: boolean = false;

  clickEventsubscription: Subscription;

   commondata : any = {}
   active
   // commondata

  allroles: any = []
  selectedRole = '13';
  selectedDetails: any = [];
  screenData: any = []
  serviceData: any = [];
  roleData: any = [];
  rolescreenMap = {};
  groupedMenu = []
  panelOpenState = false;

  communitymembers = true;
  communitymanagepage = true;

  notificationList: any = [];

  InviteUsers:any;



 values:any={}
  navigationMenu=[]
  navigationadminMenu=[]
  selectedItem
  submenuData
  membersflage = true;
  isJoined
  isAdmin
  isCommunitySuperAdmin
  joined:Boolean=false;
  isSuperAdmin:any ;
  communityType:any;

  constructor( private commonvalues: CommonValues,

    // Removed: private about: BusinessProfileComponent - component should not be injected as service
    // Removed: private follower: BusinessFollowerComponent - component should not be injected as service
    // Removed: private people: BussinessPostComponent - component should not be injected as service
    private api: ApiService,
    private util: UtilService,
    // Removed: private adminadd: BusinessAdminComponent - component should not be injected as service
    // Removed: private employee: BusinessEmployeeComponent - component should not be injected as service
    private route: ActivatedRoute
    // Removed: private inivateData: InvitesendComponent - component should not be injected as service
    ) {
       this.clickEventsubscription = this.commonvalues.getbusinessid().subscribe((res) => {
        this.commondata = res;
        this.membersflage=res.membersflage;
       })
    }

    ngOnInit() {
      setTimeout(() => {
        this.companydetailsapicall()
      }, 800);
      this.isSuperAdmin=localStorage.getItem('isSuperAdmin');
      //console.log('this.isSuperAdmin',this.isSuperAdmin)

    }

    @HostListener('window:scroll')
    handleScroll(){
      const windowScroll = window.pageYOffset;
      if(windowScroll >= 330){
        this.communitymenustick = true;
      } else {
        this.communitymenustick = false;
      }
    }

    companydetailsapicall(){
      this.route.queryParams.subscribe((res) => {
         this.values.communityId=res.communityId;
         if(res.menu == 'request'){
          this.communitymembers = false
         }
       });

       this.api.query('community/details/'+this.values.communityId).subscribe(res=>{
        this.values.joinReqCnt = res.data.communityDetails.joinReqCnt;
        this.communityType = res.data.communityDetails.communityType;
        localStorage.setItem('reqcount',res.data.communityDetails.joinReqCnt);
        },err => {
          this.util.stopLoader();
        });
    }

     ngAfterViewInit( ): void {
      setInterval(() => {
             this.values.joinReqCnt=localStorage.getItem('reqcount');
             this.values.joined = localStorage.getItem('isJoined');
             this.isSuperAdmin=localStorage.getItem('isSuperAdmin');
             this.isJoined = localStorage.getItem('isJoined')
             this.isAdmin = localStorage.getItem('communityAdmin');
             this.isCommunitySuperAdmin = localStorage.getItem('communitySuperadmin');
      }, 700);

     }



    submenu(value){
      this. companydetailsapicall();

      if(value =='managepages'){
        this.communitymembers = true;
        // this.communitymanagepage = false;
        this.communitymanagepage = false;

       }
    }


    comMethod(value: string) {

      this.companydetailsapicall();

      if (value === 'managepages') {
        this.communitymembers = true;
        this.communitymanagepage = false;
      } else if (value === 'memberspage') {
        this.communitymembers = false;
        this.communitymanagepage = true;
      }

      if (this.commondata.adminviewnavigation) {
        this.commondata.viewadmin = true;
      }

      if (value === 'communityabout') {
        // TODO: Replace with proper service call instead of component injection
        // this.about.getbussinessId(this.commondata.businessId, this.commondata.admin);
      }

      // Same detour as menuclick() below: community.component.ts only reacts and
      // scrolls to top when the incoming menu value actually differs from its
      // current one, so re-clicking Members/Manage Page while already on that
      // panel was a silent no-op. Force it through a sentinel first.
      this.commondata.menu = '__menu_refresh__';
      this.commonvalues.businessid(this.commondata);

      setTimeout(() => {
        this.commondata.menu = value;
        this.commonvalues.businessid(this.commondata);
      }, 10);
    }


  menuclick(value){

    //this.selectedItem = data;
     this.commondata.menu = value


    if(this.commondata.adminviewnavigation){
      this.commondata.viewadmin=true
     }

     // Detour through a sentinel that never matches a real menu key. community.component.ts
     // only reacts (`menu !== this.menu`) and scrolls to top when the incoming value actually
     // differs from its current one, so the detour must be both truthy (an earlier `null` was
     // skipped by that guard entirely) and guaranteed to differ from whatever menu we're
     // currently on — including when re-clicking the SAME item (e.g. Home while already on
     // Home), which the old hardcoded "communityhome" detour failed to do since it collided
     // with that specific target.
     this.commondata.menu = '__menu_refresh__';
     this.commonvalues.businessid(this.commondata);

     setTimeout(() => {
      this.commondata.menu = value;
      this.commonvalues.businessid(this.commondata);
     }, 10);


    if (value === 'communityabout'){
      // TODO: Replace with proper service call instead of component injection
      // this.about.getbussinessId( this.commondata.businessId, this.commondata.admin)

    }


  }


}


